import { Controller } from 'stimulus';

class Inspiration extends Controller {
  connect() {
    $('.js-inspiration-tab').on('shown.bs.tab', () => {
      $(this.sliderTargets).each((i, slider) => {
        $(slider).slick('setPosition');
      });
    });
  }
}

Inspiration.targets = [
  'slider',
];

export default Inspiration;
